export function triggerDownloadWithAnchorTag(
  url: string,
  fileName?: string,
  sameTab?: boolean
) {
  const $a = document.createElement('a');
  $a.setAttribute('href', url);
  if (!sameTab) {
    $a.setAttribute('target', '_blank');
  }
  $a.setAttribute('rel', 'noreferrer');
  if (fileName) {
    $a.setAttribute('download', fileName);
  }
  $a.click();
  $a.remove();
}
